import { AppServices } from '@singularsystems/neo-core';

import { Types } from './IdentityTypes';

import ProxySessionApiClient from 'st-common/Identity/ApiClients/Custom/ProxyUsers/ProxySessionApiClient';
import AcceptTermsAndConditionsApiClient from 'st-common/Identity/ApiClients/Custom/TermsAndConditions/AcceptTermsAndConditionsApiClient';
import ProxySessionQueryApiClient from 'st-common/Identity/ApiClients/Custom/ProxyUsers/ProxySessionQueryApiClient';
import ParticipantsAppProxySessionService from './Services/ParticipantsAppProxySessionService';
import { IdentityCommonRoutes, IdentityPureRoutes } from 'st-common/Identity/IdentityRoutes';
import AccountApiClient from 'st-common/Identity/ApiClients/AccountApiClient';
import ChangePasswordView from './Views/ChangePasswordView';
import TermsAndConditionsService from 'st-common/Identity/Services/TermsAndConditionsService';
import TermsAndConditionsDisplayOptionsApiClient from 'st-common/Identity/ApiClients/Custom/TermsAndConditions/TermsAndConditionsDisplayOptionsApiClient';

// Modules
const identityAppModule = new AppServices.Module("Clients", container => {
    // Api Clients
    container.bind(Types.Identity.ApiClients.AccountApiClient).to(AccountApiClient).inSingletonScope();
    container.bind(Types.Identity.ApiClients.ProxySessionApiClient).to(ProxySessionApiClient).inSingletonScope();
    container.bind(Types.Identity.ApiClients.ProxySessionQueryApiClient).to(ProxySessionQueryApiClient).inSingletonScope();
    container.bind(Types.Identity.ApiClients.AcceptTermsAndConditionsApiClient).to(AcceptTermsAndConditionsApiClient).inSingletonScope();
    container.bind(Types.Identity.ApiClients.TermsAndConditionsDisplayOptionsApiClient).to(TermsAndConditionsDisplayOptionsApiClient).inSingletonScope();
    
    // Services
    container.bind(Types.Identity.Services.ProxySessionService).to(ParticipantsAppProxySessionService).inTransientScope();
    container.bind(Types.Identity.Services.TermsAndConditionsService).to(TermsAndConditionsService).inSingletonScope();
});

// Test
const identityTestModule = new AppServices.Module("Clients", context => {
    // bind test types
});

// Routing
const ChangePasswordRoute = { path: "/change-password", component: ChangePasswordView };

export { identityAppModule, 
         identityTestModule,
         IdentityPureRoutes,
         IdentityCommonRoutes,
         ChangePasswordRoute }
